import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    FieldArray,
    getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ClienteForm from '../cliente/clienteForm';

import {
    setModoTela,
    getOpcoes,
    getAreas,
    getHistorico,
    alterarStatus
} from './aplicacaoActions';

import {
    setModoTela as setModoTelaCliente,
    initForm as initFormCliente,
    salvar as salvarCliente
} from '../cliente/clienteActions';

import {
    getLista as getListaCidade
} from '../cidade/cidadeActions';

const STATUS = {
    PEDIDO: 'PEDIDO',
    APROVACAO: 'AGUARDANDO_APROVACAO',
    APLICACAO: 'AGUARDANDO_APLICACAO',
    FINALIZADO: 'FINALIZADO'
};

const ETAPAS = [
    {
        codigo: STATUS.PEDIDO,
        descricao: 'Pedido',
        icon: 'fas fa-clipboard-list'
    },
    {
        codigo: STATUS.APROVACAO,
        descricao: 'Aprovação',
        icon: 'fas fa-clipboard-check'
    },
    {
        codigo: STATUS.APLICACAO,
        descricao: 'Aplicação',
        icon: 'fas fa-seedling'
    },
    {
        codigo: STATUS.FINALIZADO,
        descricao: 'Finalizado',
        icon: 'fas fa-flag-checkered'
    }
];

const STATUS_CONFIG = {
    [STATUS.PEDIDO]: {
        label: 'Pedido',
        cor: '#92400e',
        fundo: '#fef3c7'
    },
    [STATUS.APROVACAO]: {
        label: 'Aguardando aprovação',
        cor: '#075985',
        fundo: '#e0f2fe'
    },
    [STATUS.APLICACAO]: {
        label: 'Aguardando aplicação',
        cor: '#5b21b6',
        fundo: '#ede9fe'
    },
    [STATUS.FINALIZADO]: {
        label: 'Finalizado',
        cor: '#14532d',
        fundo: '#dcfce7'
    }
};

const PARCELAS = Array.from({ length: 6 }, (_, indice) => ({
    id: indice + 1,
    valor: indice === 0
        ? '1 vez'
        : `${indice + 1} vezes`
}));

const numero = valor => {
    const texto = (valor || 0).toString();
    return Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    ) || 0;
};

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const Fluxo = ({ status }) => {
    const atual = ETAPAS.findIndex(item =>
        item.codigo === status
    );

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                marginBottom: 18
            }}
        >
            {ETAPAS.map((item, index) => {
                const ativo = index === atual;
                const concluido = index < atual;
                const cor = concluido
                    ? '#166534'
                    : ativo
                        ? '#075bb5'
                        : '#64748b';
                const fundo = concluido
                    ? '#dcfce7'
                    : ativo
                        ? '#eaf4ff'
                        : '#f1f5f9';
                return (
                    <div
                        key={item.codigo}
                        style={{
                            flex: '1 1 150px',
                            minWidth: 135,
                            padding: '11px 12px',
                            borderRadius: 10,
                            border: `1px solid ${cor}33`,
                            fontWeight: 700,
                            color: cor,
                            background: fundo
                        }}
                    >
                        <i
                            className={
                                concluido
                                    ? 'fas fa-check'
                                    : item.icon
                            }
                            style={{ marginRight: 7 }}
                        />
                        {item.descricao}
                    </div>
                );
            })}
        </div>
    );
};

const hoje = () => {
    const data = new Date();
    data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
    return data.toISOString().substring(0, 10);
};

const ProdutosPrescricao = ({
    fields,
    readOnly,
    produtos,
    totalHectares,
    change
}) => (
    <div style={{ marginTop: 14 }}>
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 10,
                marginBottom: 10
            }}
        >
            <strong style={{ color: '#334155' }}>
                Produtos da prescrição
            </strong>
            {!readOnly &&
                <button
                    type='button'
                    className='btn btn-sm btn-success'
                    onClick={() => fields.push({
                        id_produto: null,
                        quantidade_hectare: 0,
                        preco_hectare: 0
                    })}
                >
                    <i className='fas fa-plus mr-1' />
                    Adicionar produto
                </button>}
        </div>

        {!fields.length &&
            <div
                style={{
                    padding: 14,
                    border: '1px dashed #cbd5e1',
                    borderRadius: 8,
                    color: '#64748b',
                    textAlign: 'center'
                }}
            >
                Nenhum produto informado.
            </div>}

        {fields.map((nome, index) => {
            const produto = fields.get(index) || {};
            const quantidadeTotal =
                numero(produto.quantidade_hectare) * totalHectares;
            const valorTotal =
                numero(produto.preco_hectare) * totalHectares;

            return (
                <div
                    key={nome}
                    style={{
                        padding: '12px 12px 2px',
                        marginBottom: 10,
                        borderRadius: 9,
                        border: '1px solid #dce3eb',
                        background: '#fff'
                    }}
                >
                    <Row>
                        <Select
                            name={`${nome}.id_produto`}
                            options={produtos}
                            label={`Produto ${index + 1} *`}
                            cols='12 6 4 4'
                            readOnly={readOnly}
                            value={produto.id_produto}
                            onChange={id => change(
                                `${nome}.id_produto`,
                                Number(id)
                            )}
                        />
                        <Field
                            name={`${nome}.quantidade_hectare`}
                            component={LabelAndInputNumber}
                            label='Quantidade (kg/ha) *'
                            cols='12 6 3 3'
                            casas={4}
                            readOnly={readOnly}
                        />
                        <Field
                            name={`${nome}.preco_hectare`}
                            component={LabelAndInputNumber}
                            label='Preço por hectare *'
                            cols='12 6 3 3'
                            casas={2}
                            readOnly={readOnly}
                        />
                        <Grid cols='12 6 2 2'>
                            <div className='form-group'>
                                <label>Total</label>
                                <div
                                    style={{
                                        minHeight: 38,
                                        padding: '8px 10px',
                                        borderRadius: 6,
                                        background: '#f1f5f9',
                                        textAlign: 'right',
                                        fontWeight: 700
                                    }}
                                >
                                    {moeda(valorTotal)}
                                </div>
                            </div>
                        </Grid>
                    </Row>
                    <div
                        style={{
                            margin: '-6px 0 10px',
                            color: '#64748b',
                            fontSize: 12
                        }}
                    >
                        Quantidade total prevista:{' '}
                        <strong>
                            {FormatUtils.formatarValorTela(
                                quantidadeTotal,
                                4
                            )} kg
                        </strong>
                    </div>
                    {!readOnly &&
                        <button
                            type='button'
                            className='btn btn-link text-danger p-0'
                            style={{ marginBottom: 10 }}
                            onClick={() => fields.remove(index)}
                        >
                            <i className='fas fa-trash-alt mr-1' />
                            Remover produto
                        </button>}
                </div>
            );
        })}
    </div>
);

const Prescricoes = ({
    fields,
    readOnly,
    areasCliente,
    produtos,
    change
}) => (
    <div style={{ marginTop: 22 }}>
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 10,
                marginBottom: 12
            }}
        >
            <div>
                <div
                    style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#062042'
                    }}
                >
                    <i className='fas fa-file-prescription mr-2' />
                    Prescrições
                </div>
                <small className='text-muted'>
                    Agrupe áreas e produtos em cada prescrição.
                </small>
            </div>
            {!readOnly &&
                <button
                    type='button'
                    className='btn btn-success'
                    disabled={!areasCliente.length}
                    onClick={() => fields.push({
                        data: hoje(),
                        nome: '',
                        ids_cliente_areas: [],
                        produtos: []
                    })}
                >
                    <i className='fas fa-plus mr-1' />
                    Adicionar prescrição
                </button>}
        </div>

        {!fields.length &&
            <div
                style={{
                    padding: 24,
                    border: '1px dashed #b9c4d0',
                    borderRadius: 10,
                    background: '#f8fafc',
                    color: '#64748b',
                    textAlign: 'center'
                }}
            >
                Selecione um cliente e adicione uma prescrição.
            </div>}

        {fields.map((nome, index) => {
            const prescricao = fields.get(index) || {};
            const selecionadas = (
                prescricao.ids_cliente_areas || []
            ).map(Number);
            const areasSelecionadas = areasCliente.filter(area =>
                selecionadas.includes(Number(area.id))
            );
            const totalHectares = areasSelecionadas.reduce(
                (total, area) =>
                    total + numero(area.area_hectares),
                0
            );
            const alternarArea = idArea => {
                const id = Number(idArea);
                const novosIds = selecionadas.includes(id)
                    ? selecionadas.filter(item => item !== id)
                    : [...selecionadas, id];
                change(`${nome}.ids_cliente_areas`, novosIds);
            };

            return (
                <div
                    key={nome}
                    style={{
                        padding: 16,
                        marginBottom: 16,
                        border: '1px solid #cbd5e1',
                        borderRadius: 12,
                        background: '#f8fafc',
                        boxShadow:
                            '0 3px 10px rgba(15, 35, 60, .06)'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 8,
                            color: '#075bb5',
                            fontWeight: 700
                        }}
                    >
                        <span>Prescrição {index + 1}</span>
                        {!readOnly &&
                            <button
                                type='button'
                                title='Excluir prescrição'
                                onClick={() => fields.remove(index)}
                                style={{
                                    border: 0,
                                    borderRadius: 7,
                                    padding: '6px 10px',
                                    color: '#dc3545',
                                    background: '#fff0f1'
                                }}
                            >
                                <i className='fas fa-trash-alt' />
                            </button>}
                    </div>

                    <Row>
                        <Field
                            name={`${nome}.data`}
                            component={LabelAndInput}
                            label='Data *'
                            type='date'
                            cols='12 4 3 3'
                            readOnly={readOnly}
                        />
                        <Field
                            name={`${nome}.nome`}
                            component={LabelAndInput}
                            label='Nome da prescrição *'
                            cols='12 8 9 9'
                            readOnly={readOnly}
                        />
                    </Row>

                    <div
                        style={{
                            marginBottom: 8,
                            fontWeight: 700,
                            color: '#334155'
                        }}
                    >
                        Áreas *
                    </div>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fill, minmax(185px, 1fr))',
                            gap: 10
                        }}
                    >
                        {areasCliente.map(area => {
                            const selecionada = selecionadas.includes(
                                Number(area.id)
                            );

                            return (
                                <button
                                    key={area.id}
                                    type='button'
                                    disabled={Boolean(readOnly)}
                                    onClick={() => alternarArea(area.id)}
                                    style={{
                                        padding: 12,
                                        borderRadius: 9,
                                        border: selecionada
                                            ? '2px solid #087df1'
                                            : '1px solid #cbd5e1',
                                        background: selecionada
                                            ? '#eaf4ff'
                                            : '#fff',
                                        color: '#1e293b',
                                        textAlign: 'left',
                                        cursor: readOnly
                                            ? 'default'
                                            : 'pointer'
                                    }}
                                >
                                    <i
                                        className={selecionada
                                            ? 'fas fa-check-square'
                                            : 'far fa-square'}
                                        style={{
                                            marginRight: 8,
                                            color: selecionada
                                                ? '#087df1'
                                                : '#94a3b8'
                                        }}
                                    />
                                    <strong>{area.nome}</strong>
                                    <small
                                        style={{
                                            display: 'block',
                                            margin: '4px 0 0 24px',
                                            color: '#64748b'
                                        }}
                                    >
                                        {FormatUtils.formatarValorTela(
                                            area.area_hectares,
                                            2
                                        )} ha
                                    </small>
                                </button>
                            );
                        })}
                    </div>
                    <div
                        style={{
                            marginTop: 8,
                            textAlign: 'right',
                            color: '#334155'
                        }}
                    >
                        Área total:{' '}
                        <strong>
                            {FormatUtils.formatarValorTela(
                                totalHectares,
                                2
                            )} ha
                        </strong>
                    </div>

                    <FieldArray
                        name={`${nome}.produtos`}
                        component={ProdutosPrescricao}
                        readOnly={readOnly}
                        produtos={produtos}
                        totalHectares={totalHectares}
                        change={change}
                    />
                </div>
            );
        })}
    </div>
);

let AplicacaoForm = props => {
    const [clienteAberto, setClienteAberto] = useState(false);
    const formulario = props.formulario || {};
    const status = formulario.status || STATUS.PEDIDO;
    const editavel = [
        STATUS.PEDIDO,
        STATUS.APROVACAO
    ].includes(status);
    const readOnly =
        props.excluir || !editavel ? 'readOnly' : '';
    const statusConfig =
        STATUS_CONFIG[status] || STATUS_CONFIG[STATUS.PEDIDO];
    const clienteSelecionado = (props.clientes || []).find(item =>
        String(item.id) === String(formulario.id_cliente)
    );

    useEffect(() => {
        props.getHistorico(formulario.id);
    }, [formulario.id]);

    useEffect(() => {
        if (
            !formulario.id &&
            !formulario.id_forma_pagamento
        ) {
            const formaPadrao = props.formasPagamento.find(
                item => item.codigo === 'A_VISTA'
            );

            if (formaPadrao) {
                props.change(
                    'id_forma_pagamento',
                    formaPadrao.id
                );
                props.change('quantidade_parcelas', 1);
            }
        }
    }, [
        formulario.id,
        formulario.id_forma_pagamento,
        props.formasPagamento
    ]);

    const historico = Object.values(
        (props.historico || []).reduce((grupos, item) => {
            const chave = `${item.id_usuario}-${new Date(
                item.datahora
            ).getTime()}`;
            if (!grupos[chave] || item.entidade === 'APLICACAO') {
                grupos[chave] = item;
            }
            return grupos;
        }, {})
    );
    const valorTotal = (formulario.prescricoes || []).reduce(
        (totalAplicacao, prescricao) => {
            const idsAreas = (prescricao.ids_cliente_areas || [])
                .map(Number);
            const hectares = props.areasCliente
                .filter(area => idsAreas.includes(Number(area.id)))
                .reduce(
                    (total, area) =>
                        total + numero(area.area_hectares),
                    0
                );
            const totalPrescricao = (prescricao.produtos || [])
                .reduce(
                    (total, produto) =>
                        total +
                        numero(produto.preco_hectare) * hectares,
                    0
                );

            return totalAplicacao + totalPrescricao;
        },
        0
    );
    const abrirCliente = () => {
        if (!clienteSelecionado) {
            return;
        }

        props.setModoTelaCliente(
            'cadastro',
            clienteSelecionado
        );
        props.initFormCliente(clienteSelecionado);
        props.getListaCidade();
        setClienteAberto(true);
    };

    const alterarFormaPagamento = idFormaPagamento => {
        const formaPagamento = props.formasPagamento.find(item =>
            String(item.id) === String(idFormaPagamento)
        );

        props.change(
            'id_forma_pagamento',
            Number(idFormaPagamento)
        );

        if (
            formaPagamento &&
            !formaPagamento.permite_parcelamento
        ) {
            props.change('quantidade_parcelas', 1);
        }
    };
    const fecharCliente = () => {
        props.getOpcoes();
        props.getAreas(formulario.id_cliente);
        setClienteAberto(false);
    };

    if (clienteAberto) {
        return (
            <div>
                <div
                    style={{
                        marginBottom: 14,
                        padding: '12px 16px',
                        borderRadius: 10,
                        background: '#eaf4ff',
                        border: '1px solid #bddcff',
                        color: '#075bb5',
                        fontWeight: 600
                    }}
                >
                    <i
                        className='fas fa-info-circle'
                        style={{ marginRight: 8 }}
                    />
                    Você está editando o cliente da aplicação.
                </div>

                <ClienteForm
                    onSubmit={props.salvarCliente}
                    onVoltar={fecharCliente}
                />
            </div>
        );
    }

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    {formulario.id &&
                        <React.Fragment>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 12,
                                    marginBottom: 10,
                                    padding: '13px 16px',
                                    borderRadius: 10,
                                    color: statusConfig.cor,
                                    background: statusConfig.fundo,
                                    fontWeight: 700
                                }}
                            >
                                <span>
                                    <i
                                        className='fas fa-stream'
                                        style={{ marginRight: 8 }}
                                    />
                                    Status da aplicação
                                </span>
                                <span>{statusConfig.label}</span>
                            </div>
                            <Fluxo status={status} />
                        </React.Fragment>}

                    <Row>
                        {formulario.id &&
                            <Field
                                name='numero'
                                component={LabelAndInput}
                                label='Número'
                                cols='12 3 2 2'
                                readOnly='readOnly'
                            />}
                        <Field
                            name='datahora_solicitacao'
                            component={LabelAndInput}
                            label='Data e hora *'
                            type='datetime-local'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Select
                            name='id_cliente'
                            options={props.clientes}
                            label='Cliente *'
                            cols='12 8 7 7'
                            readOnly={readOnly || !!formulario.id}
                            value={formulario.id_cliente}
                            onChange={id => {
                                props.change(
                                    'id_cliente',
                                    Number(id)
                                );
                                props.change('prescricoes', []);
                                props.getAreas(id);
                            }}
                        />
                        {editavel && !props.excluir &&
                            <Grid cols='12 4 3 3'>
                                <button
                                    type='button'
                                    disabled={!clienteSelecionado}
                                    onClick={abrirCliente}
                                    style={{
                                        width: '100%',
                                        minHeight: 42,
                                        marginTop: 28,
                                        border: '1px solid #0879df',
                                        borderRadius: 9,
                                        background: clienteSelecionado
                                            ? '#087df1'
                                            : '#dbe2ea',
                                        color: clienteSelecionado
                                            ? '#fff'
                                            : '#7b8794',
                                        cursor: clienteSelecionado
                                            ? 'pointer'
                                            : 'not-allowed',
                                        fontWeight: 600
                                    }}
                                >
                                    <i
                                        className='fas fa-user-edit'
                                        style={{ marginRight: 8 }}
                                    />
                                    Abrir cadastro do cliente
                                </button>
                            </Grid>}
                    </Row>

                    <Row>
                        <Select
                            name='id_tipo'
                            options={props.tipos}
                            label='Tipo de aplicação *'
                            cols='12 6 6 6'
                            readOnly={readOnly}
                            value={formulario.id_tipo}
                            onChange={id =>
                                props.change('id_tipo', Number(id))}
                        />
                    </Row>

                    <div
                        style={{
                            margin: '8px 0 10px',
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#062042'
                        }}
                    >
                        <i className='fas fa-user-check mr-2' />
                        Dados do aplicador
                    </div>
                    <Row>
                        <Field
                            name='nome_aplicador'
                            component={LabelAndInput}
                            label='Nome *'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                        />
                        <Field
                            name='email_aplicador'
                            component={LabelAndInput}
                            label='E-mail *'
                            type='email'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                        />
                        <Field
                            name='celular_aplicador'
                            component={LabelAndInput}
                            label='Telefone *'
                            type='tel'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Select
                            name='ids_veiculos'
                            options={props.veiculos}
                            label='Veículos utilizados'
                            cols='12 12 12 12'
                            multiple
                            readOnly={readOnly}
                            value={formulario.ids_veiculos || []}
                            onChange={itens =>
                                props.change(
                                    'ids_veiculos',
                                    (itens || []).map(item =>
                                        Number(item.value)
                                    )
                                )}
                        />
                    </Row>

                    <FieldArray
                        name='prescricoes'
                        component={Prescricoes}
                        readOnly={readOnly}
                        areasCliente={props.areasCliente}
                        produtos={props.produtos}
                        change={props.change}
                    />

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndTextarea}
                            label='Observação da aplicação'
                            cols='12 12 12 12'
                            rows={3}
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Select
                            name='id_forma_pagamento'
                            options={props.formasPagamento}
                            label='Forma de pagamento *'
                            cols='12 6 4 4'
                            placeholder='Selecione'
                            readOnly={readOnly}
                            value={formulario.id_forma_pagamento}
                            onChange={alterarFormaPagamento}
                        />

                        <Select
                            name='quantidade_parcelas'
                            options={PARCELAS}
                            label='Parcelas *'
                            cols='12 6 3 3'
                            placeholder='Selecione'
                            readOnly={
                                readOnly ||
                                !(
                                    props.formasPagamento.find(item =>
                                        String(item.id) ===
                                        String(formulario.id_forma_pagamento)
                                    ) || {}
                                ).permite_parcelamento
                            }
                            value={formulario.quantidade_parcelas}
                            onChange={valor =>
                                props.change(
                                    'quantidade_parcelas',
                                    Number(valor)
                                )}
                        />
                    </Row>

                    <Row>
                        {Array.from(
                            {
                                length:
                                    Number(
                                        formulario.quantidade_parcelas
                                    ) || 1
                            },
                            (_, indice) => (
                                <Field
                                    key={indice}
                                    name={indice === 0
                                        ? 'data_primeiro_vencimento'
                                        : `datas_vencimentos[${indice}]`}
                                    component={LabelAndInput}
                                    label={
                                        `${indice + 1}º vencimento *`
                                    }
                                    type='date'
                                    cols='12 6 4 3'
                                    readOnly={readOnly}
                                />
                            )
                        )}
                    </Row>

                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-end',
                            gap: 10,
                            marginTop: 18
                        }}
                    >
                        {[
                            {
                                label: 'Total geral',
                                valor: valorTotal
                            }
                        ].map(item => (
                            <div
                                key={item.label}
                                style={{
                                    minWidth: 170,
                                    padding: '12px 14px',
                                    borderRadius: 10,
                                    background: '#f3f7fb',
                                    border: '1px solid #dce3eb'
                                }}
                            >
                                <small className='text-muted'>
                                    {item.label}
                                </small>
                                <div
                                    style={{
                                        fontSize: 18,
                                        fontWeight: 700,
                                        color: '#062042'
                                    }}
                                >
                                    {moeda(item.valor)}
                                </div>
                            </div>
                        ))}
                    </div>

                    {formulario.id &&
                        <div
                            style={{
                                marginTop: 22,
                                padding: 16,
                                borderRadius: 10,
                                background: '#f8fafc',
                                border: '1px solid #dce3eb'
                            }}
                        >
                            <div
                                style={{
                                    marginBottom: 12,
                                    fontWeight: 700,
                                    color: '#062042'
                                }}
                            >
                                <i
                                    className='fas fa-history'
                                    style={{ marginRight: 8 }}
                                />
                                Histórico de alterações
                            </div>
                            {historico.map(item => (
                                <div
                                    key={item.id}
                                    style={{
                                        padding: '8px 0',
                                        borderTop:
                                            '1px solid #e2e8f0'
                                    }}
                                >
                                    <strong>{item.nome_usuario}</strong>
                                    {' '}
                                    {item.operacao === 'INCLUSAO'
                                        ? 'incluiu'
                                        : item.operacao === 'EXCLUSAO'
                                            ? 'excluiu'
                                            : 'alterou'}
                                    {' a aplicação.'}
                                    {item.status_anterior &&
                                        item.status_novo &&
                                        item.status_anterior !==
                                        item.status_novo &&
                                        ` Status alterado de ${item.nome_status_anterior} para ${item.nome_status_novo}.`}
                                    <small
                                        className='text-muted'
                                        style={{
                                            display: 'block'
                                        }}
                                    >
                                        {new Date(
                                            item.datahora
                                        ).toLocaleString('pt-BR')}
                                    </small>
                                </div>
                            ))}
                        </div>}
                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='12 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')}
                            />
                        </Grid>

                        {props.excluir &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Excluir pedido'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />
                            </Grid>}

                        {!props.excluir && editavel &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text={
                                        formulario.id
                                            ? 'Salvar alterações'
                                            : 'Criar aplicação'
                                    }
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status !== STATUS.PEDIDO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Reabrir pedido'
                                    type='warning'
                                    icon='fas fa-undo'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.PEDIDO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.PEDIDO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Enviar para aprovação'
                                    type='info'
                                    icon='fas fa-paper-plane'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.APROVACAO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.APROVACAO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Aprovar aplicação'
                                    type='success'
                                    icon='fas fa-thumbs-up'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.APLICACAO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.APLICACAO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Finalizar aplicação'
                                    type='success'
                                    icon='fas fa-flag-checkered'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.FINALIZADO
                                        )}
                                />
                            </Grid>}
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

AplicacaoForm = reduxForm({
    form: 'aplicacaoForm',
    destroyOnUnmount: false
})(AplicacaoForm);

const opcoes = (itens, campo) =>
    (itens || []).map(item => ({
        ...item,
        valor: item[campo]
    }));

const mapStateToProps = state => ({
    formulario: getFormValues('aplicacaoForm')(state) || {},
    clientes: opcoes(state.aplicacao.clientes, 'razao_social'),
    produtos: opcoes(state.aplicacao.produtos, 'nome'),
    unidades: opcoes(
        state.aplicacao.unidades,
        'sigla'
    ),
    veiculos: opcoes(
        state.aplicacao.veiculos,
        'placa_nome'
    ),
    tipos: opcoes(state.aplicacao.tipos, 'descricao'),
    formasPagamento: (
        state.aplicacao.formas_pagamento || []
    ).map(item => ({
        ...item,
        valor: item.descricao
    })),
    areasCliente: opcoes(
        state.aplicacao.areasCliente,
        'nome'
    ),
    historico: state.aplicacao.historico
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        getOpcoes,
        getAreas,
        getHistorico,
        alterarStatus,
        setModoTelaCliente,
        initFormCliente,
        salvarCliente,
        getListaCidade
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AplicacaoForm);
